




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import {
  CampaignItemPaymentItemType
} from '@/modules/campaign-item-payment/models/campaign-item-payment-resource.model'

@Component
export default class CampaignItemPaymentItemTypeView extends Vue {
  @Prop({ required: true }) type!: CampaignItemPaymentItemType
  @Prop({ required: true }) types!: { [key in CampaignItemPaymentItemType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case CampaignItemPaymentItemType.CONTENT_ITEM:
        return 'text-tes-orange'
      default:
        return ''
    }
  }
}
